type SessionExpiredHandler = () => void

let handler: SessionExpiredHandler | null = null

export const setSessionExpiredHandler = (fn: SessionExpiredHandler | null): void => {
  handler = fn
}

export const showSessionExpired = (): void => {
  handler?.()
}
